<script setup lang="ts">
import { DialogContent, type DialogContentEmits, type DialogContentProps, DialogOverlay, DialogPortal, useForwardPropsEmits } from 'radix-vue';
import { computed, type HTMLAttributes } from 'vue';
import { cn } from '@/lib/utils';

const props = defineProps<DialogContentProps & { class?: HTMLAttributes['class'] }>();
const emits = defineEmits<DialogContentEmits>();

const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props;

    return delegated;
});

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
    <DialogPortal>
        <DialogOverlay
            class="fixed inset-0 z-[2000] grid place-items-center overflow-y-auto bg-background/80 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 py-6"
        >
            <DialogContent
                :class="
                    cn(
                        'sm:max-w-[480px] relative z-50 grid w-full max-w-lg gap-y-6 gap-x-4 border border-gray-200 bg-white p-8 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 sm:rounded-lg md:w-full',
                        props.class
                    )
                "
                v-bind="forwarded"
                @interact-outside="(event) => {
                    // Prevent closing the dialog when clicking on the toast close button or container
                    if ((event.target as HTMLElement)?.closest('.Vue-Toastification__close-button') || (event.target as HTMLElement)?.closest('.Vue-Toastification__toast')) {
                        event.preventDefault();
                    }
                }"
            >
                <slot />
            </DialogContent>
        </DialogOverlay>
    </DialogPortal>
</template>
